import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { BACKEND_BASE_URL } from "../config/app.config";

const config: AxiosRequestConfig = {
  baseURL: BACKEND_BASE_URL,
};

const API: AxiosInstance = axios.create(config);

export default API;
